(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faf-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faf-desktop-navigation')) {
    customElements.define('faf-desktop-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.buttons = [...this.querySelectorAll('.faf-desktop-nav__trigger')];
        this.panels = [...this.querySelectorAll('.faf-desktop-panel')];
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            clearTimeout(this.hoverTimer);
            this.toggle(button.getAttribute('aria-expanded') === 'true' ? -1 : index);
          }, options);
          button.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown') {
              event.preventDefault(); this.toggle(index); this.panels[index].querySelector('a')?.focus();
            }
          }, options);
          button.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
            clearTimeout(this.hoverTimer); clearTimeout(this.closeTimer);
            this.hoverTimer = setTimeout(() => {
              if (!this.panels[this.activeIndex]?.contains(document.activeElement)) this.toggle(index);
            }, 200);
          }, options);
          button.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), options);
        });
        this.querySelectorAll('[data-faf-close]').forEach(button => button.addEventListener('click', () => this.close(true), options));
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.activeIndex >= 0) { event.preventDefault(); event.stopPropagation(); this.close(true); }
        }, options);
        this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
        this.addEventListener('pointerleave', () => {
          clearTimeout(this.hoverTimer);
          this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 250);
        }, options);
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.close(); });
        }, options);
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, options);
        this.media = matchMedia('(min-width: 1100px)');
        this.media.addEventListener('change', () => this.close(), options);
      }
      toggle(index) {
        this.activeIndex = index;
        this.buttons.forEach((button, i) => button.setAttribute('aria-expanded', String(i === index)));
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      }
      close(restoreFocus = false) {
        clearTimeout(this.hoverTimer); clearTimeout(this.closeTimer);
        const button = this.buttons[this.activeIndex]; this.toggle(-1);
        if (restoreFocus) button?.focus();
      }
      disconnectedCallback() { this.abort?.abort(); clearTimeout(this.hoverTimer); clearTimeout(this.closeTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faf-sleep-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faf-sleep-addons')) customElements.define('faf-sleep-addons', class extends HTMLElement {
  connectedCallback() {
    if (this.controller || !this.closest('section.faf-sleep-product[id^="MainProduct-"]') || this.closest('quick-add-modal,quick-view-modal,floated-form')) return;
    this.controller = new AbortController();
    try {
      this.data = JSON.parse(this.querySelector('[data-addon-mattress]').textContent);
      this.cards = [...this.querySelectorAll('[data-addon-card]')].map(card => ({ card, data: JSON.parse(card.querySelector('[data-addon-base]').textContent) }));
    } catch { return; }
    this.productSection = this.closest('section.faf-sleep-product');
    this.sync(this.data.variants.find(variant => String(variant.id) === String(this.data.currentId)));
    this.optionObserver = new MutationObserver(() => this.setPending());
    this.optionObserver.observe(this.productSection, { subtree: true, attributes: true, attributeFilter: ['aria-busy'] });
    this.cards.forEach(({ card }) => {
      card.querySelector('form').addEventListener('submit', event => {
        const button = card.querySelector('[type="submit"]');
        if (!card.querySelector('[name="id"]').value || button.disabled || button.classList.contains('loading') || this.isPending()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal: this.controller.signal });
    });
    document.addEventListener('variant:change', event => {
      if (String(event.detail?.sectionId) === this.dataset.sectionId) this.sync(this.data.variants.find(variant => String(variant.id) === String(event.detail?.variant?.id)));
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); this.optionObserver?.disconnect(); this.controller = null; }
  isPending() {
    return !!this.productSection?.querySelector('variant-selects[aria-busy="true"], variant-radios[aria-busy="true"], [data-variant-request-error]:not([hidden])');
  }
  setPending() {
    const pending = this.isPending();
    this.cards.forEach(({card}) => {
      const button = card.querySelector('[type="submit"]');
      button.disabled = !card.querySelector('[name="id"]').value || pending;
      button.setAttribute('aria-disabled', String(button.disabled || button.classList.contains('loading')));
    });
  }
  sync(variant) {
    const size = String(variant?.options[this.data.sizeIndex] || '').trim().toLowerCase();
    let matchingCount = 0;
    this.cards.forEach(({ card, data }) => {
      const match = data.variants.find(candidate => candidate.available && String(candidate.size).trim().toLowerCase() === size);
      const input = card.querySelector('[name="id"]');
      const button = card.querySelector('[type="submit"]');
      card.hidden = !match;
      if (match) matchingCount++;
      input.value = match ? match.id : '';
      button.disabled = !match;
      button.setAttribute('aria-disabled', String(!match || button.classList.contains('loading')));
      card.querySelector('[data-addon-status]').textContent = match ? `${this.data.match} ${match.size}` : this.data.unavailable;
      card.querySelector('[data-addon-price]').textContent = match ? match.price : '';
      const url = new URL(data.url, location.origin);
      if (match) url.searchParams.set('variant', match.id);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      card.querySelectorAll('a').forEach(link => { link.href = url.toString(); });
    });
    this.querySelector('[data-addon-help]').hidden = matchingCount > 0;
    const announcement = this.querySelector('[data-addon-announcement]');
    const nextStatus = matchingCount > 0 ? announcement.dataset.available : announcement.dataset.unavailable;
    if (this.lastMatchStatus !== undefined && this.lastMatchStatus !== nextStatus) announcement.textContent = nextStatus;
    this.lastMatchStatus = nextStatus;
    this.setPending();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faf-sleep-buybox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faf-sleep-buybox')) {
    customElements.define('faf-sleep-buybox', class FafSleepBuybox extends HTMLElement {
      connectedCallback() {
        if (this.abortController || !this.closest('section.faf-sleep-product[id^="MainProduct-"]') || this.closest('quick-add-modal, quick-view-modal, floated-form')) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const catalogElement = this.querySelector('[data-sleep-catalog]');
        if (!catalogElement) return;
        try { this.catalog = JSON.parse(catalogElement.textContent); } catch { return; }
        this.currentProduct = this.catalog.products[this.catalog.currentHandle];
        if (!this.currentProduct) return;
        this.links = [...this.querySelectorAll('[data-sleep-link]')];
        this.tabs = [...this.querySelectorAll('[data-sleep-tab]')];
        this.panels = [...this.querySelectorAll('[data-sleep-panel]')];
        this.querySelector('[data-sleep-tablist]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab) => {
          tab.setAttribute('role', 'tab');
          tab.addEventListener('click', () => this.selectTab(tab), options);
          tab.addEventListener('keydown', (event) => {
            const index = this.tabs.indexOf(tab);
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.selectTab(this.tabs[next]);
            this.tabs[next].focus();
          }, options);
        });
        this.panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('tabindex', '0');
          panel.setAttribute('aria-labelledby', this.tabs.find((tab) => tab.dataset.sleepTab === panel.dataset.sleepPanel).id);
        });
        this.selectTab(this.tabs[0]);
        this.updateLinks(this.currentProduct.variants.find((variant) => String(variant.id) === String(this.catalog.currentVariant)));
        document.addEventListener('variant:change', (event) => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          const variant = this.currentProduct.variants.find((candidate) => String(candidate.id) === String(event.detail?.variant?.id));
          this.updateLinks(variant);
        }, options);
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-sleep-link][aria-disabled="true"]')) event.preventDefault();
        }, options);
        this.dataset.ready = '';
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
      selectTab(selected) {
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.sleepPanel !== selected.dataset.sleepTab; });
      }
      normalizeSize(value) {
        const size = String(value || '').trim().toLowerCase();
        return size === 'twin long' ? 'twin xl' : size;
      }
      matchingVariant(product, size) {
        if (!product || !size) return null;
        return product.variants.find((variant) => variant.available && this.normalizeSize(variant.options[product.sizeIndex]) === size) || null;
      }
      updateLinks(currentVariant) {
        const size = currentVariant ? this.normalizeSize(currentVariant.options[this.catalog.sizeIndex]) : '';
        this.links.forEach((link) => {
          const product = this.catalog.products[link.dataset.sleepLink];
          const variant = this.matchingVariant(product, size);
          const availability = link.querySelector('[data-sleep-availability]');
          const difference = link.querySelector('[data-sleep-delta]');
          if (variant && product.url) {
            const destination = new URL(product.url, window.location.origin);
            destination.searchParams.set('variant', variant.id);
            const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (previewId) destination.searchParams.set('preview_theme_id', previewId);
            link.href = destination.toString();
            link.removeAttribute('aria-disabled');
            link.removeAttribute('tabindex');
            link.removeAttribute('title');
            if (availability) availability.textContent = '';
            if (difference) difference.textContent = variant.differenceLabel;
          } else {
            link.removeAttribute('href');
            link.setAttribute('aria-disabled', 'true');
            link.setAttribute('tabindex', '-1');
            link.title = this.catalog.unavailable;
            if (availability) availability.textContent = ` — ${this.catalog.unavailable}`;
            if (difference) difference.textContent = this.catalog.unavailable;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faf-sleep-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faf-sleep-gallery')) customElements.define('faf-sleep-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.controller || !this.closest('section.faf-sleep-product') || this.closest('quick-add-modal,quick-view-modal,floated-form')) return;
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-index]')];
    this.dialog = this.querySelector('dialog');
    this.thumbTrack = this.querySelector('.faf-sleep-gallery__thumbs');
    if (!this.slides.length) return;
    this.slides.forEach((slide, index) => { slide.dataset.slide = index; });
    this.thumbs.forEach((thumb, index) => { thumb.dataset.index = index; });
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.show(0, false);
    this.addEventListener('click', event => {
      const thumb = event.target.closest('[data-index]');
      const step = event.target.closest('[data-step]');
      const slide = event.target.closest('[data-slide]');
      if (thumb) this.show(this.thumbs.indexOf(thumb));
      if (step) this.show(this.index + Number(step.dataset.step));
      if (slide) {
        const image = slide.querySelector('img');
        const zoom = this.querySelector('[data-zoom-image]');
        if (image && zoom && this.dialog && !this.dialog.open) {
          this.show(this.slides.indexOf(slide), false);
          zoom.replaceChildren(image.cloneNode(true));
          this.dialog.showModal();
        }
      }
      if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog?.close();
    }, options);
    this.thumbTrack?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1);
      this.show(next);
      this.thumbs[this.index]?.focus();
    }, options);
    this.addEventListener('touchstart', event => {
      if (!event.target.closest('.faf-sleep-gallery__stage') || !event.changedTouches.length) return;
      this.touchX = event.changedTouches[0].clientX;
      this.touchY = event.changedTouches[0].clientY;
    }, { ...options, passive: true });
    this.addEventListener('touchend', event => {
      if (!event.target.closest('.faf-sleep-gallery__stage') || !event.changedTouches.length || this.touchX === undefined) return;
      const dx = event.changedTouches[0].clientX - this.touchX;
      const dy = event.changedTouches[0].clientY - this.touchY;
      this.touchX = undefined;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
    }, { ...options, passive: true });
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.touchX = undefined;
    if (this.dialog?.open) this.dialog.close();
  }
  show(index, scroll = true) {
    if (!this.slides?.length || !Number.isFinite(index)) return;
    this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
    this.thumbs.forEach((thumb, position) => { thumb.setAttribute('aria-pressed', String(position === this.index)); });
    const count = this.querySelector('[data-count]');
    if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
    const thumb = this.thumbs[this.index];
    if (scroll && thumb && this.thumbTrack) this.thumbTrack.scrollTo({ left: thumb.offsetLeft - 100, top: thumb.offsetTop - 100, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
});
  } catch(e) { console.error(e); }
})();

})();
